// extracted by mini-css-extract-plugin
module.exports = {"steps":"Steps_steps__Ngmw6","dot":"Steps_dot__i3Jr6","dotWaiting":"Steps_dotWaiting__l7ZNd","stepsSecondary":"Steps_stepsSecondary__uyp_L"};